import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import useSearch from 'hooks/useSearch';
import usePagination from 'hooks/usePagination';
import SearchBarA from 'components/SearchBar/SearchBarA';
import BuildChildren from 'utils/BuildChildren';
import PaginationA from 'components/Pagination/PaginationA';
import CardListMessageA from 'components/CardListMessage/CardListMessageA';
import classNames from 'classnames';
import classes from './CardListA.module.scss';

const CardListA = (props) => {
  const {
    items: listOfItems = [],
    itemIncrement = 10,
    divided = false,
    categories = [],
    categoryLabel = '',
    fields = [],
  } = props;

  const [keyword, setKeyword] = useState('');
  const [searchableFields, setSearchableFields] = useState(fields);
  const [items, setItems] = useState(listOfItems);
  const [activePage, setActivePage] = useState(1);
  const [isShowingAll, setShowingAll] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    setSearchableFields(searchableFields);
    setItems(items);
  }, [
    searchableFields,
    setSearchableFields,
    items,
    setItems,
  ]);

  const { filteredItems } = useSearch({ keyword, listOfItems: items, fields: searchableFields });
  const {
    itemsOnPage,
    pageCount,
  } = usePagination({ items: filteredItems, page: activePage, itemsPerPage: itemIncrement });

  const onShowAllClicked = (evt) => {
    evt.preventDefault();
    setShowingAll(true);
  };

  const displayedItems = isShowingAll ? filteredItems : itemsOnPage;
  const isSingleView = listOfItems.length === 1;

  return (
    <div className={classes.container} ref={containerRef}>
      {!isSingleView && (<SearchBarA
        keyword={keyword}
        setKeyword={setKeyword}
        setActivePage={setActivePage}
        setShowingAll={setShowingAll}
      />)}
      {!isSingleView && (<CardListMessageA
        categories={categories}
        itemsPerPage={itemIncrement}
        totalItemsLength={filteredItems.length}
        itemsOnPageLength={displayedItems.length}
        categoryLabel={categoryLabel}
        onShowAllClicked={(evt) => onShowAllClicked(evt)}
        withShowAll
      />)}
      <div className={classes.itemsContainer}>
        {items.map((item, i) => (
          <div
            className={classNames(
              divided ? classes.itemDivided : classes.item,
              !displayedItems.includes(item) && classes.hide,
            )}
            key={`${item.type}-${i}`}
          >
            {BuildChildren({ isPartOfList: !isSingleView, ...item })}
          </div>
        ))}
      </div>
      {
        !isSingleView && !isShowingAll && (
          <PaginationA
            containerRef={containerRef}
            pageCount={pageCount}
            setActivePage={setActivePage}
            activePage={activePage}
          />
        )
      }
    </div>
  );
};

CardListA.propTypes = {
  items: PropTypes.array, // items in list
  itemIncrement: PropTypes.number, // number of items to display at a time
  divided: PropTypes.bool, // divider lines between items
  categories: PropTypes.array, // categories or product categories used to filter items in the widget
  categoryLabel: PropTypes.string, // Text to be used after the category list
  fields: PropTypes.array, // searchable fields in items
};

export default CardListA;
